import { useSyncExternalStore } from "react";

function subscribe() {
  return () => {}; // No-op subscribe
}

function useIsClient(): boolean {
  const isClient = useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  );

  return isClient;
}

export default useIsClient;
